import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import ActivityDetail from './components/ActivityDetail';
import StravaAnalysisPage from './components/StravaAnalysisPage';
import AuthCallback from './components/AuthCallback';
import { StravaProvider, useStrava } from './contexts/StravaContext';
import './App.css';

// Demo component to show the analysis page
const DemoAnalysisPage = () => {
  const { activities } = useStrava();
  const sampleActivity = activities[0] || {
    id: 1,
    name: 'Morning Tempo Run',
    distance: 8047,
    moving_time: 2400,
    total_elevation_gain: 45,
    type: 'Run',
    start_date: '2024-01-15T07:30:00Z',
    average_speed: 3.35,
    max_speed: 4.2
  };
  return <StravaAnalysisPage activity={sampleActivity} />;
};

function App() {
  return (
    <StravaProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/activity/:id" element={<ActivityDetail />} />
              <Route path="/analysis" element={<DemoAnalysisPage />} />
              <Route path="/auth" element={<AuthCallback />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </StravaProvider>
  );
}

export default App;